import { defineI18nConfig } from "#i18n";
import en from "~~/package/locales/en";
import es from "~~/package/locales/es";
import vi from "~~/package/locales/vi";
import ko from "~~/package/locales/ko";
import ja from "~~/package/locales/ja";
import enSeo from "~~/package/locales/en/seo";
import koSeo from "~~/package/locales/ko/seo";

export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: 'en',
  messages: {
    en: {...en, seo: enSeo},
    es,
    vi,
    ko: {...ko, seo: koSeo},
    ja
  }
}));
